import { render } from "./order_menu.vue?vue&type=template&id=23b3ac5b&scoped=true"
import script from "./order_menu.vue?vue&type=script&lang=js"
export * from "./order_menu.vue?vue&type=script&lang=js"

import "./order_menu.vue?vue&type=style&index=0&id=23b3ac5b&lang=scss&scoped=true"

import exportComponent from "D:\\Word\\mingyou\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b3ac5b"]])

export default __exports__